import { render } from "./ModalOverlay.vue?vue&type=template&id=e055851a&scoped=true&ts=true"
import script from "./ModalOverlay.vue?vue&type=script&lang=ts"
export * from "./ModalOverlay.vue?vue&type=script&lang=ts"

import "./ModalOverlay.vue?vue&type=style&index=0&id=e055851a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e055851a"]])

export default __exports__